const document_type = {
    'PERSONAL': 'personal',
    'BANK': 'bank',
    'OTHER': 'other'
};

export default document_type;
